// Shared class tokens used by primitives. Keep these tight — every entry
// is a contract other components rely on.

// Focus ring: visible only on keyboard focus, sized for 4.5:1 contrast over
// any of our surface colors. Used by every interactive primitive.
export const focusRing =
  'focus:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:ring-purple-600';

// Surface tokens — keep these in sync with the marketing-site aesthetic.
export const surface = {
  card: 'bg-white border border-gray-200 rounded-2xl shadow-sm',
  cardInteractive:
    'bg-white border border-gray-200 rounded-2xl shadow-sm hover:shadow-md hover:border-gray-300 transition-shadow',
  panel: 'bg-gray-50 border border-gray-200 rounded-xl',
};

// Text tokens — use these instead of arbitrary `text-gray-XXX` classes.
// NOTE: tailwind.config.js also emits these as literal utilities named
// `text.heading` etc. (escaped class names), because ~1,200 legacy sites
// wrote the object path as a literal string in className. Keep this map the
// single source of truth for both paths.
export const text = {
  heading: 'text-gray-900 font-bold',
  body: 'text-gray-700',
  strong: 'text-gray-800',
  // gray-600, not gray-300: secondary text still has to pass contrast on
  // white (gray-300 was ~1.6:1 — illegible, and a WCAG failure).
  secondary: 'text-gray-600',
  muted: 'text-gray-500',
  subtle: 'text-gray-400',
  danger: 'text-red-700',
  success: 'text-green-700',
};

// Motion-respecting transition helper. Components should use this rather
// than raw `transition-*` so prefers-reduced-motion is honored.
export const motion = 'transition-colors motion-reduce:transition-none';

// Keyboard-shortcut hint pill (for tooltips and "?" overlays).
export const kbd =
  'inline-flex items-center px-1.5 py-0.5 text-[10px] font-mono uppercase tracking-wider rounded border border-gray-200 bg-gray-50 text-gray-600';
